// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"43713435","137":"94714ee6","193":"db560747","238":"04ede548","381":"e4f544b5","397":"fb6f0fae","438":"c7d8d0b8","453":"9332b3a5","455":"340c0593","572":"44f39e5d","680":"59bf6792","704":"f49acc6a","782":"cac69cf9","974":"ee2e417c","977":"d27c3a7f"}[chunkId] + ".chunk.js";
};